var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 82,
    viewBox: "0 0 142 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2449 80.2313C69.7215 80.2313 69.1981 80.0896 68.7341 79.8298C67.4137 79.0621 36.377 60.5089 36.377 20.6506C36.377 19.4933 37.055 18.4422 38.1138 17.9698L69.0078 3.95151C69.7929 3.59722 70.697 3.59722 71.4821 3.95151L102.364 17.9698C103.423 18.454 104.101 19.4933 104.101 20.6506C104.101 60.5089 73.0762 79.0503 71.7557 79.8298C71.2918 80.1014 70.7684 80.2313 70.2449 80.2313ZM42.3607 22.5402C43.2053 52.9033 64.3564 69.6615 70.2449 73.7477C76.1335 69.6615 97.2846 52.9033 98.1292 22.5402L70.2449 9.89187L42.3607 22.5402V22.5402Z",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9258 44.7908H111.358",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5391 27.8191H36.389",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0586 41.9563H30.136",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0078 4.62451H49.4295",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9043 53.6838H44.2055",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7832 67.9614H93.6346",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.711 72.1426H110.718",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.104 29.792H108.291",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4297 4.62451H99.0223",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.979 22.7188H136.15",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.289 13.3059H119.436",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6074 67.9614H54.1264",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.998 76.2051H47.8941",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3555 78.8035H97.2292",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.438 35.7915H140.91",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.289 60.4749H123.112",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 64.3367H25.3388",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 15.3376H28.111",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.215 51.854H133.914",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2793 32.0474H15.8578",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1 46.7981H9.27964",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5661 67.9622C27.5831 67.9622 29.2182 66.3389 29.2182 64.3366C29.2182 62.3342 27.5831 60.7109 25.5661 60.7109C23.5492 60.7109 21.9141 62.3342 21.9141 64.3366C21.9141 66.3389 23.5492 67.9622 25.5661 67.9622Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.435 39.4182C121.452 39.4182 123.087 37.795 123.087 35.7926C123.087 33.7902 121.452 32.167 119.435 32.167C117.418 32.167 115.783 33.7902 115.783 35.7926C115.783 37.795 117.418 39.4182 119.435 39.4182Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.291 64.1004C110.308 64.1004 111.943 62.4771 111.943 60.4747C111.943 58.4724 110.308 56.8491 108.291 56.8491C106.274 56.8491 104.639 58.4724 104.639 60.4747C104.639 62.4771 106.274 64.1004 108.291 64.1004Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3103 35.0703C19.3273 35.0703 20.9624 33.4471 20.9624 31.4447C20.9624 29.4423 19.3273 27.8191 17.3103 27.8191C15.2933 27.8191 13.6582 29.4423 13.6582 31.4447C13.6582 33.4471 15.2933 35.0703 17.3103 35.0703Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6501 8.25125C41.6671 8.25125 43.3022 6.628 43.3022 4.62562C43.3022 2.62325 41.6671 1 39.6501 1C37.6331 1 35.998 2.62325 35.998 4.62562C35.998 6.628 37.6331 8.25125 39.6501 8.25125Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M119.435 16.9314C121.452 16.9314 123.087 15.3082 123.087 13.3058C123.087 11.3034 121.452 9.68018 119.435 9.68018C117.418 9.68018 115.783 11.3034 115.783 13.3058C115.783 15.3082 117.418 16.9314 119.435 16.9314Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1562 37.1498V50.0697L86.0435 26.3438",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2478 10.1995C72.2648 10.1995 73.8999 8.57624 73.8999 6.57386C73.8999 4.57149 72.2648 2.94824 70.2478 2.94824C68.2308 2.94824 66.5957 4.57149 66.5957 6.57386C66.5957 8.57624 68.2308 10.1995 70.2478 10.1995Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2478 81C72.2648 81 73.8999 79.3768 73.8999 77.3744C73.8999 75.372 72.2648 73.7488 70.2478 73.7488C68.2308 73.7488 66.5957 75.372 66.5957 77.3744C66.5957 79.3768 68.2308 81 70.2478 81Z",
    fill: "white",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4c6eddfb521d52b044865a0368d6c710.svg";
export { ForwardRef as ReactComponent };